import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';

    public data: any = {
        email: '',
        password: '',
        username: '',
        nickname: ''
    };

    public async ngOnInit() {
        await this.service.init();
        const params = new URLSearchParams(window.location.search);
        const requestedView = params.get('view');
        if (requestedView === 'signup' || requestedView === 'login') {
            this.view = requestedView;
        }
        let check = await this.service.auth.check();
        if (check) return await this.redirectToHome();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        // user.password = this.service.auth.hash(user.password);

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            const redirectUrl = data?.redirectUrl || await this.sessionHomeUrl();
            if (!redirectUrl) {
                await this.alert("연결된 미니홈피를 찾지 못했습니다.", 'error');
                return;
            }
            location.href = redirectUrl;
            await this.service.render();
        } else {
            await this.alert(data?.message || "로그인에 실패했습니다.", 'error');
        }
    }

    public async signup() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!user.username) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }
        if (user.password.length < 8) {
            await this.alert("비밀번호는 8자 이상이어야 합니다.");
            return;
        }

        let { code, data } = await wiz.call("signup", user);

        if (code == 200) {
            location.href = data?.redirectUrl || `/dashboard/${data?.minihompy?.slug || user.username}/home`;
            await this.service.render();
        } else {
            await this.alert(data?.message || "회원가입에 실패했습니다.", 'error');
        }
    }

    public switchView(view: string) {
        this.view = view;
    }

    private async redirectToHome() {
        const redirectUrl = await this.sessionHomeUrl();
        if (redirectUrl) {
            location.href = redirectUrl;
            return;
        }
    }

    private async sessionHomeUrl(): Promise<string> {
        try {
            const { code, data } = await wiz.call("session_home", {});
            if (code == 200 && data?.redirectUrl) {
                return data.redirectUrl;
            }
        } catch (error) {
            // Keep the access form usable if the session helper is unavailable.
        }
        return "";
    }
}

export default PageAccessComponent;